import { render, staticRenderFns } from "./SimpleOptionMenuIcon.vue?vue&type=template&id=601ca4b0&"
import script from "./SimpleOptionMenuIcon.vue?vue&type=script&lang=js&"
export * from "./SimpleOptionMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports